var Approval = (function() {
	var __private = {
		dataset: {
			url    : "approval",
			type   : "type",
			option : "option",
			status : "statusController",
			request: "request"
		},
		type: {
			resolve: "approve",
			reject : "reject"
		},
		option: {
			simple: "table"
		},
		infoTagID: {
			status   : "itemStatus-",
			reason   : "itemReason-",
			attention: "attention-"
		},
		info: {

		},
		request: {
			ajax  : "ajax",
			submit: "submit"
		},
		disabledClass: "disabled",
		showPopClass : "show",
		textareaName : "reason",
		hiddenIdName : "id",
		tokenInpName : "_token",

		listener() {
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;
				var form = null;

				if((target instanceof HTMLInputElement || target instanceof HTMLButtonElement) && target.dataset[__private.dataset.url] !== undefined && target.dataset[__private.dataset.type] !== undefined) {
					event.preventDefault();

					form = target.form;

					let DATA;
					let url  = target.dataset[__private.dataset.url];
					let type = target.dataset[__private.dataset.type];

					if(form instanceof HTMLFormElement && !form.classList.contains("js__dealerApproval")) {
						let requestType = form.dataset[__private.dataset.request];

						__private.disabled(target, true);

						if(requestType === undefined || requestType === __private.request.ajax) {

							DATA = new FormData(form);
							if(form.querySelector(`input[type='hidden'][name='${__private.tokenInpName}']`)) 
								DATA.append(__private.tokenInpName, document.querySelector(`meta[name='csrf-token']`).content);

							Ajax.post(url, DATA)
								.then(response => {
									var hidden = form.querySelector(`input[type='hidden'][name='${__private.hiddenIdName}']`);
									var itemID = null;

									if(hidden) itemID = +hidden.value;

									return itemID;
								})
								.then(ID => __private.status(ID, form))
								.then(() => {
									var popupOpenButton = form.querySelector(`*[data-popup-id]`);
									var popup = null;

									if(popupOpenButton) popup = document.getElementById(popupOpenButton.dataset.popupId);

									return popup;
								})
								.then(popup => {
									if(popup instanceof HTMLElement) popup.classList.remove(__private.showPopClass);
								})
								.catch(error => {
									__private.disabled(target, false);
									console.error(`Reject: ${error}`);
								});

						} else {
							__private.submit(form, target.dataset[__private.dataset.url]);
						}
					}
				}
			});
		},

		textarea() {
			var textareas = document.querySelectorAll(`textarea[name*="${this.textareaName}"]`);

			for (let i = 0; i < textareas.length; i++) {
				const t = textareas[i];
				const form = t.form;
				let rejBtn = null;

				if(form instanceof HTMLFormElement) rejBtn = form.querySelector(`*[data-type='${this.type.reject}']`);

				if(rejBtn instanceof HTMLElement) {
					t.addEventListener("input", function() {
						var value = this.value;

						if(value || value !== "") {
							rejBtn.disabled = false;
							rejBtn.classList.remove(__private.disabledClass);
						} else {
							rejBtn.disabled = true;
							rejBtn.classList.add(__private.disabledClass);
						}
					});
				}
			}
		},

		submit(form, action) {
			form.action = action;
			form.submit();
		},

		disabled(button, flag) {
			if(button instanceof HTMLInputElement || button instanceof HTMLButtonElement) {
				button.disabled = flag;

				if(button.disabled) button.classList.add(__private.disabledClass);
				else button.classList.remove(__private.disabledClass);
			}
		},

		status(ID, form) {
			var urlVariable;
			var url;

			if(form instanceof HTMLFormElement && form.dataset[this.dataset.status] !== undefined) {
				urlVariable = form.dataset[this.dataset.status];
				url = `/ajax/${urlVariable}/${ID}/status`;
			} else {
				url = false;
				return;
			}

			if(ID && ID !== null && url)
				Ajax.get(url)
					.then(response => {
						var data = JSON.parse(response.responseText);
						var approveBtn  = null;
						var rejectBtn   = null;
						var can_approve = data.can_approve;
						var can_reject  = data.can_reject;

						if(form.dataset[this.dataset.status] === "users") {
							can_approve = data.can_approve_license;
							can_reject  = data.can_reject_license;
						}

						if(form instanceof HTMLFormElement) {
							approveBtn = form.getElementsByClassName(this.type.resolve)[0];
							rejectBtn  = form.getElementsByClassName(this.type.reject)[0];

							this.disabled(approveBtn, !can_approve);
							this.disabled(rejectBtn, !can_reject);
						}

						return data;
					})
					.then(data => __private.setInfo(ID, data))
					.catch(error   => console.error(error));
		},

		switcher() {
			var hiddenInputs = document.querySelectorAll(`input[type='hidden'][name='${this.hiddenIdName}']`);

			for (let i = 0; i < hiddenInputs.length; i++) {
				const h = hiddenInputs[i];
				const form = h.form;
				let ID  = +h.value;

				if(!isNaN(ID)) this.status(ID, form);
			}
		},

		setInfo(ID, data) {
			var statusText = data.status.name;
			var reasonText = data.rejection_reason;
			var isReason   = data.is_rejected;
			var statusElem = document.getElementById(`${this.infoTagID.status}${ID}`);
			var reasonElem = document.getElementById(`${this.infoTagID.reason}${ID}`);
			var lattention = document.getElementById(`${this.infoTagID.attention}${ID}`);

			// status
			if(statusElem instanceof HTMLElement && statusText)
				statusElem.innerHTML = `<b>Listing status:</b> <span class="red">${statusText}</span>`;

			// license data
			if(data.hasOwnProperty("license_rejection_reason")) {
				reasonText = data.license_rejection_reason;
				isReason   = data.has_rejected_license;
			}

			// reason
			if(reasonElem instanceof HTMLElement && reasonText && isReason) {
				if(reasonElem.dataset[this.dataset.option] !== undefined) {
					switch (reasonElem.dataset[this.dataset.option]) {
						case this.option.simple:
							reasonElem.innerHTML = `<span>${reasonText}</span>`;
							break;
					
						default:
							reasonElem.innerHTML = `<span>${reasonText}</span>`;
							break;
					}
				} else reasonElem.innerHTML = `<b>Rejection Reason:</b> <span class="red">${reasonText}</span>`;
			}

			// license attention
			if(lattention instanceof HTMLElement) {
				if(isReason) lattention.style.display = "block";
				else lattention.style.display = "none";
			}
		}
	};

	return {
		init() {
			__private.switcher();
			__private.listener();
			__private.textarea();
		}
	};
})();


/**
 * Run module
 */
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var forms = document.getElementsByClassName("js__reject-listing-form");

		if(forms.length > 0) Approval.init();
	});
})();